const COPIED_TEXT = "COPIED_TEXT";

export const updateCopiedText = (text) => ({ type: COPIED_TEXT, text });

const copiedText = (state = null, payload = {}) => {
  const { type, text } = payload;
  return type === COPIED_TEXT ? text : state;
};

export default copiedText;
